import React from 'react';

export interface IShowMiniatureContext {
  showMiniature: boolean;
  setShowMiniature: (value: boolean) => void;
}

export const ShowMiniatureContext = React.createContext<Partial<IShowMiniatureContext>>({});

export const useShowMiniatureContext = () => React.useContext(ShowMiniatureContext);
